export default "__VITE_ASSET__983ef2df__"